import React, { useState, useEffect } from "react";
import "./shift.edit.css";
import {
  Typography,
  Button,
  Form,
  Select,
  InputNumber,
  DatePicker,
  Table,
  Skeleton,
  Image,
  Dropdown,
  Modal,
  Menu,
} from "antd";
import moment from "moment";
import {
  RollbackOutlined,
  ClockCircleOutlined,
  MoreOutlined,
} from "@ant-design/icons";
import { swalNotification } from "../../../components/alret/notificztion";
import Pageloader from "../../../components/loader";
import { useParams } from "react-router-dom";
import { userhasPermissionHelper, validationErrors } from "../../../utils/Helpers";
import RiderReAssignModal from "../../../components/modal/shift/riderReAssignModal";
import _ from "lodash";
import * as shiftActions from "../../../redux/actions/shift.actions";
import * as batchActions from "../../../redux/actions/batch.action";
import * as zoneActions from "../../../redux/actions/zone.actions";
import * as riderActions from "../../../redux/actions/rider.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useNavigate } from "react-router-dom";
import { PERMISSION_CONSTANT } from "../../../utils/constants/app";
import {getShiftTypesAction} from "../../../redux/actions/shift.actions";

const { Text, Title, Link } = Typography;

const ShiftView = (props) => {
  const { shiftId } = useParams();
  const pagename = "Shift";
  const navigate = useNavigate();
  const [postData, setPostData] = useState(null);
  const [zoneData, setZoneData] = useState(null);
  const [shiftData, setShiftData] = useState(null);
  const [shiftRidersData, setShiftRidersData] = useState(null);
  const [shiftTypeData, setShiftTypeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [riderReAssignModal, setRiderReAssignModal] = useState(false);
  const [riderId, setRiderId] = useState(null);
  const [riderName, setRiderName] = useState("");
  const [zoneRiders, setZoneRiders] = useState("");
  const [totalPages, setTotalPages] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(100);

  useEffect(() => {
    postLists();
    // getShiftRiders();
  }, []);

  useEffect(() => {
    setShiftData(props.shigleShiftData);
  }, [props.shigleShiftData]);

  useEffect(() => {
    setPostData(props.batchData);
  }, [props.batchData]);

  useEffect(() => {
    setZoneData(props.zoneData);
  }, [props.zoneData]);

  useEffect(() => {
    setShiftRidersData(props.singleShiftRiderData);
  }, [props.singleShiftRiderData]);

  useEffect(() => {
    setShiftTypeData(props.shiftTypeData);
  }, [props.shiftTypeData]);
  
  useEffect(() => {
    setTotalPages(props.singleShiftRiderPagination.totalCount);
    setCurrentPageSize(props.singleShiftRiderPagination.limit);
    setCurrentPage(props.singleShiftRiderPagination.currentPage);
  }, [props.singleShiftRiderPagination]);

  useEffect(() => {
    setZoneRiders(props.riderData);
  }, [props.riderData]);

  const postLists = async () => {
    try {
      setLoading(true);
      const shift = await props.shiftActions.getSingleShiftAction(shiftId);
      const shiftTypes = await props.shiftActions.getShiftTypesAction();

      await props.batchActions.getBatchListAction();
      await props.zoneActions.getZoneListAction();
      const data = {
        page: currentPage,
        limit: currentPageSize,
      };
      await props.shiftActions.getSingleShiftRidersAction(shiftId, data);
      if (shift.zone.id != null) {
        await props.riderActions.getRidersByZoneAction(shift.zone.id);
      }
    } catch (error) {
      validationErrors(error);
    } finally {
      setLoading(false);
    }
  };

  const filtersWithPagination = async (shiftId, data) => {
    try {
      setLoading(true);
      await props.shiftActions.getSingleShiftRidersAction(shiftId, data);
    } catch (error) {
      validationErrors(error);
    } finally {
      setLoading(false);
    }
  };

  const characterLength = (value) => {
    return value.length > 10 ? `${value.substring(0, 10)}...` : value;
  };

  const handleClick = async (id, type) => {
    const riderShiftId = { riderId: id, shiftId: shiftId };
    try {
      const resp = await props.shiftActions.riderShiftRemoveAction(
        riderShiftId
      );
      postLists();
      swalNotification("Rider Shift Remove", resp.message, "success");
    } catch (error) {
      validationErrors(error);
    }
  };

  const handleClickActions = async (id, type) => {
    if (type === "active") {
      const shift_id = { shiftId: id };
      try {
        await props.shiftActions.shiftActiveAction(shift_id);
        postLists();
      } catch (error) {
        validationErrors(error);
      }
    }
    if (type === "inactive") {
      const shift_id = { shiftId: id };
      try {
        await props.shiftActions.shiftInActiveAction(shift_id);
        postLists();
      } catch (error) {
        validationErrors(error);
      }
    }
  };

  const handleOk = async () => {
    const riderBatch = { riderId: riderId };
  };

  const handleCancel = () => {
    setRiderReAssignModal(false);
  };

  const riderColumns = [
    {
      title: "Rider ID",
      render: (riderId) => (riderId ? <Text>{riderId.display_id}</Text> : "--"),
      dataIndex: "riderId",
    },
    {
      title: "Tookan Rider ID",
      render: (riderId) => (riderId ? <Text>{riderId.fleet_id}</Text> : "--"),
      dataIndex: "riderId",
    },
    {
      title: "Image",
      dataIndex: "riderId",
      // key: "profileImage",
      render: (riderId) => {
        return riderId ? (
          <Image alt="Profile Image" src={riderId.profileImage} />
        ) : (
          <Skeleton.Image active />
        );
      },
    },
    {
      title: "Name",
      render: (riderId) =>
        riderId ? <Text>{characterLength(riderId.fullName)}</Text> : "",
      dataIndex: "riderId",
    },
    // {
    //   title: "Email",
    //   render: (email) => (email ? <Text>{characterLength(email)}</Text> : ""),
    //   dataIndex: "email",
    // },
    {
      title: "Phone Number",
      dataIndex: "riderId",
      render: (riderId) =>
        riderId ? <Text>{riderId.phoneNumber}</Text> : "--",
    },
    {
      title: "Shift Started At",
      dataIndex: "statuslogs",
      render: (statuslogs) =>
        statuslogs ? <Text>{ statuslogs.length > 0 ? moment(statuslogs[0].createdAt).format("DD MMMM yyyy, h:mm:ss A") : "--" }</Text> : "--",
    },
    {
      title: "Selfie Uploded",
      dataIndex: "statuslogs",
      render: (statuslogs) => {
        return statuslogs ? (
          statuslogs.length > 0 ?
            <Image alt="Selfie Image" src={statuslogs[0].selfieImageUrl} />
          : 
            <Skeleton.Image active />
        ) : (
          <Skeleton.Image active />
        );
      },
    },
    {
      title: "Selfie Mached",
      dataIndex: "statuslogs",
      render: (statuslogs) => 
        statuslogs ? <Text>{statuslogs.length > 0 ? statuslogs[0].compareSelfieMached?.toFixed(2) : "--"}</Text> : "--"
    },
    {
      title: "Status",
      render: (riderId) => {
        return riderId ? (
          <Text
            type={[
              riderId.status === "available" && riderId.is_approved === true
                ? "success"
                : riderId.status === "blocked" && riderId.is_approved === true
                ? "danger"
                : riderId.status === "pending" && riderId.is_approved === false
                ? "warning"
                : "",
            ]}
          >
            {riderId.status === "available" && riderId.is_approved === true
              ? "Active"
              : riderId.status === "pending" && riderId.is_approved === false
              ? "Verification Pending"
              : riderId.status === "blocked" && riderId.is_approved === true
              ? "Blocked"
              : ""}
          </Text>
        ) : (
          ""
        );
      },
      dataIndex: "riderId",
    },
    // {
    //   title: "CNIC",
    //   dataIndex: "cnic",
    //   key: "cnic",
    // },
    {
      title: "Action",
      render: (record) => {
        return (
          <Dropdown
            disabled={
              currentDateTimeStamp >=
              Number(record.shiftDuration * 3600) + Number(record.startTime)
                ? true
                : false
            }
            overlay={() =>
              actions(
                record.riderId._id,
                record.riderId.fullName,
                record.riderId.status
              )
            }
            onClick={(e) => {}}
          >
            <Link
              href="#"
              type={[
                record.status === "active"
                  ? "success"
                  : record.status === "inactive"
                  ? "danger"
                  : "",
              ]}
            >
              <Button
                disabled={
                  currentDateTimeStamp >=
                  Number(record.shiftDuration * 3600) + Number(record.startTime)
                    ? true
                    : false
                }
              >
                <MoreOutlined />
              </Button>
            </Link>
          </Dropdown>
        );
      },
    },
  ];

  const riderReAssign = (id, name, batch) => {
    setRiderId(id);
    setRiderName(name);
    setRiderReAssignModal(true);
  };

  const actions = (riderId, riderName, riderStatus) => {
    const handlePressOk = async (riderId, status) => {
      setIsDisabled(true);
      let evens = _.remove(shiftRidersData, function (n) {
        return n.riderId._id != riderId;
      });
      setShiftRidersData(evens);
      await handleClick(riderId, status);
    };
    return (
      <Menu
        items={[
          userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_SHIFT_REMOVE_RIDER) &&
          ({
            key: "1",
            label: (
              <div
                style={{
                  pointerEvents: riderStatus === "false" ? "none" : "auto",
                }}
              >
                <a
                  onClick={() =>
                    Modal.confirm({
                      content:
                        "Are you sure you want to remove " + riderName + "?",
                      centered: true,
                      maskClosable: true,
                      onOk: async () =>
                        await handlePressOk(riderId, riderStatus),
                    })
                  }
                  // disabled={riderStatus === "approved" ? true : false}
                >
                  Remove
                </a>
              </div>
            ),
          }),
          userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_SHIFT_REASSIGN_RIDER) &&
          ({
            key: "3",
            label: (
              <a onClick={() => riderReAssign(riderId, riderName)}>Re-assign</a>
            ),
          }),
        ]}
      />
    );
  };

  let currentDateTimeStamp = moment().format("X");

  const data = [];
  {
    shiftRidersData &&
      shiftRidersData.map((v, i) => {
        data.push(v.riderId);
      });
  }

  const RiderReAssignShiftLocal = async (values) => {
    await props.shiftActions
      .RiderReAssignShiftAction(values)
      .then((riderReAssignShift) => {
        if (riderReAssignShift.code === 200) {
          swalNotification(
            "Rider Re-Assign Shift",
            "Rider re-assign successfully.",
            "success"
          );
        }
        postLists();
      });
  };
  const onFinish = async (values) => {
    values.shiftId = shiftId;
    const riderShiftId = { riderId: values.riderRemoveId, shiftId: shiftId };
    try {
      setLoading(true);
      await props.shiftActions
        .riderShiftRemoveAction(riderShiftId)
        .then((riderRemoveShift) => {
          if (riderRemoveShift.code === 200) {
            delete values["riderRemoveId"];
            RiderReAssignShiftLocal(values);
          }
        });
    } catch (error) {
      validationErrors(error);
    } finally {
      setLoading(false);
      setRiderReAssignModal(false);
    }
  };

  const [search] = useState("");

  const pageChange = (page, pageSize) => {
    globalSearch(search, "", "", page, pageSize);
  };

  const globalSearch = (
    search,
    status,
    fleet_id,
    display_id,
    // zone,
    // start_date,
    // end_date,
    currentPage,
    currentPageSize
  ) => {
    const data = {
      keyword: search,
      fleet_id: fleet_id != "" ? fleet_id : "",
      status: status != "" ? status : "",
      id: display_id != "" ? display_id : "",
      page: currentPage,
      limit: currentPageSize,
    };

    filtersWithPagination(data);
    return postData;
  };

  const shiftActions = (shiftId, shiftDisplayId, shiftStatus) => {
    const handlePressOk = async (shiftId, status) => {
      setIsDisabled(true);
      await handleClickActions(shiftId, status);
    };
    return (
      <Menu
        items={[
          userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.EDIT_SHIFTS) &&
          (shiftStatus == true ? 
            ""
            : 
            {
              key: "1",
              label: (
                <a
                  href={`/shifts/shiftEdit/${shiftId}`}
                  disabled={shiftStatus === true ? true : false}
                  style={{
                    pointerEvents: shiftStatus === true ? "none" : "auto",
                  }}
                >
                  Edit {pagename}
                </a>
              ),
            }
          ),
          // {
          //   key: "2",
          //   label: <a href={`/rider/${riderId}`}>View {pagename}</a>,
          // },
          // {
          //   key: "2",
          //   label: <a onClick={() => AssignBatchModal()}>Assign Batch</a>,
          // },
          // {
          //   key: "3",
          //   label: <a onClick={() => AssignZoneModal()}>Assign Zone</a>,
          // },
          userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_SHIFT_ACTIVE) &&
          (shiftStatus == true ? 
            ""
            : 
            {
              key: "2",
              label: (
                <div
                  style={{
                    pointerEvents: shiftStatus === "false" ? "none" : "auto",
                  }}
                >
                  <a
                    onClick={() =>
                      Modal.confirm({
                        content:
                          "Are you sure you want to activate " +
                          shiftDisplayId +
                          " shift?",
                        centered: true,
                        maskClosable: true,
                        onOk: async () =>
                          await handlePressOk(shiftId, "active"),
                      })
                    }
                    // disabled={riderStatus === "approved" ? true : false}
                  >
                    {shiftStatus === false ? "Active" : ""}
                  </a>
                </div>
              ),
            }
          ),
          userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_SHIFT_INACTIVE) &&
          (shiftStatus == false ? 
            ""
            : 
            {
              key: "3",
              label: (
                <div
                  style={{
                    pointerEvents: shiftStatus === "false" ? "none" : "auto",
                  }}
                >
                  <a
                    onClick={() =>
                      Modal.confirm({
                        content:
                          "Are you sure you want to deactivate " +
                          shiftDisplayId +
                          " shift?",
                        centered: true,
                        maskClosable: true,
                        onOk: async () =>
                          await handlePressOk(shiftId, "inactive"),
                      })
                    }
                    // disabled={riderStatus === "approved" ? true : false}
                  >
                    {shiftStatus === true ? "Inactive" : ""}
                  </a>
                </div>
              ),
            }
          ),
        ]}
      />
    );
  };

  return (
    <div className="page-content">
      <div className="page-content-header">
        <div className="pch-title">
          <Title level={2}>{pagename} View</Title>
        </div>
        <div className="pch-content">
          {/* {console.log("ddd ", shiftData)} */}
          {shiftData && (
            <Dropdown disabled={loading=== true || currentDateTimeStamp >= Number(shiftData.shiftDuration * 3600) + Number(shiftData.startTime) ? true:false}
              overlay={() => shiftActions(shiftData.id, shiftData.display_id, shiftData.isActive ) }
              onClick={(e) => {
                // console.log(
                //   "corresponding id and status is :",
                //   shiftData._id + " " + shiftData.isActive
                // );
              }}
            >
              <Link
                href="#"
                // className={proId.status == "active" ? "active" : ""}
                type={[
                  shiftData.status === "active"
                    ? "success"
                    : shiftData.status === "inactive"
                    ? "danger"
                    : "",
                ]}
                // {[
                //   proId.status == "active" ? "success" : "",
                //   proId.status == "inactive" ? "danger" : "",
                // ]}
              >
                <Button disabled={loading=== true || currentDateTimeStamp >=Number(shiftData.shiftDuration * 3600) + Number(shiftData.startTime)?true:false}>
                  <MoreOutlined />
                </Button>
              </Link>
            </Dropdown>
          )}
          <Button onClick={() => navigate("/shifts")}>
            <RollbackOutlined />
          </Button>
        </div>
      </div>
      {loading ? (<Pageloader />) : <>
        <Text>
          Shift ID <b>{shiftData && shiftData.display_id}</b>
        </Text>
        {shiftData && (
          <Form initialValues={shiftData}>
            <div className="customTable">
              <table>
                <thead>
                <tr>
                  <th>Zone</th>
                  <th>Start Date Time</th>
                  <th>End Date Time</th>
                  <th>Total Slots</th>
                  <th>Filled Slots</th>
                  <th>Shift Types</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>
                    <Form.Item
                        name={"zone"}
                        valuePropName="option"
                        rules={[{required: true, message: "Zone is Required"}]}
                    >
                      {/* {console.log(zoneData)} */}
                      <Select
                          disabled
                          showSearch
                          placeholder="Select a Zone"
                          optionFilterProp="children"
                          value={shiftData.zone.zoneName}
                      >
                        {zoneData &&
                            zoneData.map((zone) => {
                              return (
                                  <Select.Option key={zone._id} value={zone._id}>
                                    {zone.zoneName}
                                  </Select.Option>
                              );
                            })}
                      </Select>
                    </Form.Item>
                  </td>
                  <td>
                    <Form.Item
                        // name={"start"}
                        rules={[
                          {
                            required: true,
                            message: "Please add start date time",
                          },
                        ]}
                        // label="Start Time"
                        // rules={[{ required: true }]}
                    >
                      {/* <RangePicker showTime/> */}
                      <DatePicker
                          disabled
                          format="YYYY-MM-DD HH:mm:ss"
                          // value={moment(shiftData.startTime * 1000)}
                          showTime
                          defaultValue={moment(shiftData.startTime * 1000)}
                      />
                    </Form.Item>
                  </td>
                  <td>
                    <Form.Item
                        // name={"endTime"}
                        rules={[
                          {
                            required: true,
                            message: "Please add end date time",
                          },
                        ]}
                    >
                      <DatePicker
                          disabled
                          format="YYYY-MM-DD HH:mm:ss"
                          defaultValue={moment(shiftData.endTime * 1000)}
                      />
                    </Form.Item>
                  </td>
                  {/* <td>
                    <Form.Item
                      name={"shiftDuration"}
                      rules={[
                        {
                          required: true,
                          message: "Please add shift duration hours",
                        },
                      ]}
                    >
                      <InputNumber
                        placeholder="Shift Duration"
                        min={0.1}
                        disabled
                      />
                    </Form.Item>
                  </td> */}
                  <td>
                    <Form.Item
                        name={"totalSlots"}
                        rules={[
                          {
                            required: true,
                            message: "Please add total number of slots",
                          },
                        ]}
                    >
                      <InputNumber
                          disabled
                          placeholder="Total Slots"
                          min={1}
                          formatter={(value) => `${value}`}
                          parser={(value) => value.replace(".", "")}
                      />
                    </Form.Item>
                  </td>
                  <td>
                    <Form.Item
                        name={"totalSlotsFilled"}
                        rules={[
                          {
                            required: true,
                            message: "Please add filled number of slots",
                          },
                        ]}
                    >
                      <InputNumber
                          disabled
                          placeholder="Filled Slots"
                          min={1}
                          formatter={(value) => `${value}`}
                          parser={(value) => value.replace(".", "")}
                      />
                    </Form.Item>
                  </td>
                  <td>
                    <Form.Item
                        name={"type"}
                        valuePropName="option"
                        rules={[{required: false}]}
                    >
                      {/* {console.log(zoneData)} */}
                      <Select
                          disabled
                          showSearch
                          placeholder="Select a Shift Type"
                          optionFilterProp="children"
                          value={shiftData.type}
                      >
                        {shiftTypeData &&
                            shiftTypeData.map((shiftType) => {
                              return (
                                  <Select.Option key={shiftType} value={shiftType}>
                                    {shiftType}
                                  </Select.Option>
                              );
                            })}
                      </Select>
                    </Form.Item>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            
            <Form.List name={"batchList"}>
              {(fields, {add, remove}) => (
                  <div className="customTable">
                    <table>
                      <thead>
                      <tr>
                        <th>Batch</th>
                        <th>Slots Quota</th>
                        <th>Slots Filled</th>
                        <th>Show Time</th>
                        <th>Expiry Time</th>
                        {/* <th>Action</th> */}
                      </tr>
                      </thead>
                      <tbody>
                      {fields.map((field, index) => {
                        return (
                            <tr key={field.key}>
                              <td>
                                <Form.Item
                                    key={field.key}
                                    name={[field.name, "batchId"]}
                                    rules={[
                                      {
                                        required: true,
                                    message: "Batch Level is Required",
                                  },
                                ]}
                              >
                                <Select
                                  disabled
                                  placeholder="Select Batch"
                                  // onChange={(key, val) =>
                                  //   handleOnValuesChange(key, val)
                                  // }
                                >
                                  {postData.map((b, i) => {
                                    return (
                                      <Select.Option
                                        key={b.batch.id}
                                        value={b.batch.id}
                                        disabled={b.disabled}
                                      >
                                        {b.batch.batchLevel}
                                      </Select.Option>
                                    );
                                  })}
                                </Select>
                              </Form.Item>
                            </td>
                            <td>
                              <Form.Item
                                key={field.key}
                                name={[field.name, "maxSlots"]}
                                // label={`${index + 1}-batch`}
                                rules={[
                                  {
                                    required: true,
                                    message: "Slots is Required",
                                  },
                                ]}
                              >
                                <InputNumber
                                  disabled
                                  placeholder="Slots Quota"
                                  min={1}
                                  // prefix={<PercentageOutlined />}
                                  formatter={(value) => `${value}`}
                                  parser={(value) => value.replace(".", "")}
                                />
                              </Form.Item>
                            </td>
                            <td>
                              <Form.Item
                                key={field.key}
                                name={[field.name, "slotsFilled"]}
                                // label={`${index + 1}-batch`}
                                rules={[
                                  {
                                    required: true,
                                    message: "Slots is Required",
                                  },
                                ]}
                              >
                                <InputNumber
                                  disabled
                                  placeholder="Slots Filled"
                                  min={1}
                                  // prefix={<PercentageOutlined />}
                                  formatter={(value) => `${value}`}
                                  parser={(value) => value.replace(".", "")}
                                />
                              </Form.Item>
                            </td>
                            <td>
                              <Form.Item
                                key={field.key}
                                name={[field.name, "startDisplayHours"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Show Time is Required",
                                  },
                                ]}
                              >
                                <InputNumber
                                  disabled
                                  placeholder="Show Time"
                                  min={1}
                                  prefix={<ClockCircleOutlined />}
                                  formatter={(value) => `${value}`}
                                  parser={(value) => value.replace(".", "")}
                                />
                              </Form.Item>
                            </td>
                            <td>
                              <Form.Item
                                key={field.key}
                                name={[field.name, "endDisplayHours"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Expiry Time is Required",
                                  },
                                ]}
                              >
                                <InputNumber
                                  disabled
                                  placeholder="Expiry Time"
                                  prefix={<ClockCircleOutlined />}
                                  formatter={(value) => `${value}`}
                                  parser={(value) => value.replace(".", "")}
                                />
                              </Form.Item>
                            </td>
                            {/* <td>
                            <MinusCircleOutlined
                              style={{ height: 40, color: "red" }}
                              onClick={() => remove(field.name)}
                            />
                          </td> */}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </Form.List>
            <Form.Item>
              {/* <Button className="submit" htmlType="submit">
                Submit
              </Button> */}
            </Form.Item>
          </Form>
        )}
      </>}

      {loading ? (<Pageloader />) : <>
        <Title>Shift Riders</Title>
        <div className="p-content">
          {/* {errMsg && <Result status="warning" title={errMsg} />} */}
          <Table
            dataSource={shiftRidersData}
            columns={riderColumns}
            pagination={{
              current: currentPage,
              pageSize: currentPageSize,
              pageSizeOptions: ["10", "20", "30", "40", "50", "100"],
              showSizeChanger: true,
              total: totalPages, // total count returned from backend
              onChange: (page, pageSize) => {
                pageChange(page, pageSize);
              },
            }}
            onRow={(r) => ({
              onDoubleClick: (e) => window.open(`/rider/${r.riderId._id}`),
            })}
          />
        </div>
      </>}

      {riderReAssignModal && (
        <RiderReAssignModal
          riderId={riderId}
          riderName={riderName}
          riderReAssignModal={riderReAssignModal}
          handleOk={handleOk}
          handleCancel={handleCancel}
          zoneRiders={zoneRiders}
          onFinish={onFinish}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    shigleShiftData: state.ShiftReducer.shigleShiftData,
    singleShiftRiderData: state.ShiftReducer.singleShiftRiderData,
    singleShiftRiderPagination: state.ShiftReducer.singleShiftRiderPagination,
    shiftTypeData: state.ShiftReducer.shiftTypes,
    batchData: state.BatchReducer.batchData,
    zoneData: state.ZoneReducer.zoneData,
    riderData: state.RiderReducer.riderData,
    permissions: state.PermissionReducer.permissions,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    batchActions: bindActionCreators(batchActions, dispatch),
    shiftActions: bindActionCreators(shiftActions, dispatch),
    zoneActions: bindActionCreators(zoneActions, dispatch),
    riderActions: bindActionCreators(riderActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShiftView);
